import {
  WorkArrangements,
  WorkTypes,
  EndDate,
  JobTitle,
  PositionFormattedDescriptions,
  SeekVideo
} from './PositionProfiles';

# Position profiles

A [`PostedPositionProfile`] represents a [job ad] posted to the SEEK job board.
This is in contrast to a [`PositionOpening`], which represents an open position at a hirer’s organization.

Provide input fields for the hirer to:

- Set the position title, work type, and end date
- Optionally embed a YouTube video at the top or bottom of their job ad

## End date

An [`end`] date can be specified for the job ad.
This is the date when the job ad will be closed and removed from the SEEK job board.
It can be set to a maximum period of 30 calendar days.

<EndDate />

## Position formatted descriptions

Hirers specify a position summary and description which can be used for the [`positionFormattedDescriptions`] input.
Some [ad products] have additional features such as [search bullet points].

<PositionFormattedDescriptions />

## Position title

Hirers must specify a [`positionTitle`] for the job posting.
This is a short phrase describing the position as it would be listed on a business card or in a company directory.

<JobTitle />

## Video

Hirers can set a [`seekVideo`] which specifies a YouTube URL that will be embedded at the top or bottom of the job ad.

<SeekVideo />

## Work arrangements

Hirers can specify whether the role is hybrid, on-site or remote by selecting a single value for [`seekWorkArrangementCodes`].
Although not currently mandatory on the SEEK API, this attribute is mandatory for hirers to set.

<WorkArrangements />

## Work type

Hirers can specify a [`seekAnzWorkTypeCode`] to specify the type of work for the job posting.
This is a code that represents the type of work, such as full-time, part-time, or casual.

<WorkTypes />

[`end`]: /schema/named-type/CreatePostingInstructionInput#/field/end
[`positionFormattedDescriptions`]: /schema/named-type/PositionFormattedDescriptionInput
[`PositionOpening`]: /schema/named-type/PositionOpening
[`positionTitle`]: /schema/named-type/PositionProfile#/field/positionTitle
[`PostedPositionProfile`]: /schema/named-type/PostedPositionProfile
[`seekAnzWorkTypeCode`]: /schema/named-type/PositionProfile#/field/seekAnzWorkTypeCode
[`seekVideo`]: /schema/named-type/PositionProfile#/field/seekVideo
[`seekWorkArrangementCodes`]: /schema/named-type/PostedPositionProfile#/field/seekWorkArrangementCodes
[ad products]: /use-cases/job-posting/ad-selection
[job ad]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad
[search bullet points]: /schema/named-type/AdvertisementProductFeatures#/field/searchBulletPoints
